export default {
  title: 'User Groups',

  general: {
    notifications: {
      insert: {
        success: 'User group added successfully',
        error: 'Add user group failed'
      },

      edit: {
        success: 'User group successfully edited',
        error: 'User group editing encountered an error'
      },

      delete: {
        success: 'User group successfully deleted',
        error: 'The user group could not be found.',
        cantDelete: 'The user group could not be deleted because it has a subgroup.'
      },

      deleteUser: {
        success: 'User successfully deleted from group',
        error: 'Delete user from group has error'
      }
    },

    validators: {
      name: 'Group name is not entered correctly',
      nameCantEmpty: 'Name could not be empty',
      activeSessionCount: 'Active sessions should be less than equal 5',
      permissions: 'No access selected'
    },

    confirmations: {
      delete: {
        title: 'Delete User Group',
        body: 'Are you sure you want to delete {name}?'
      },

      deleteUser: {
        title: 'Delete User From User Group',
        body: 'Are you sure you want to delete {name} from this group?'
      }
    },

    accessNames: {
      operator: 'Operator',
      ceo: 'CEO'
    },

    permissions: {
      event_menu: 'Messages',
      event: {
        show: 'View Messages',
        create: 'Add Message',
        update: 'Edit Message',
        delete: 'Delete Message'
      },
      user_management_menu: 'People',
      user_menu: 'People List',
      user: {
        show: 'View People',
        show_transactions: 'View People Transactions',
        create: 'Add Person',
        update: 'Fully Edit Person',
        delete: 'Temporarily Delete Person',
        restore: 'Restore Person',
        forceDelete: 'Permanently Delete Person',
        set_role: 'Assign Role to Person',
        set_group: 'Assign Customer Group to Person',
        set_max_debt: 'Assign Credit to Person'
      },
      user_group_menu: 'Customer Groups',
      user_group: {
        show: 'View Customer Groups',
        create: 'Add Customer Group',
        update: 'Fully Edit Customer Group',
        delete: 'Temporarily Delete Customer Group',
        restore: 'Restore Customer Group',
        forceDelete: 'Permanently Delete Customer Group',
        assign_to_user: 'Assign Customer Group to Customer'
      },
      role_menu: 'Access Levels',
      role: {
        show: 'View Access Levels',
        create: 'Add Access Level',
        update: 'Fully Edit Access Level',
        delete: 'Delete Access Level'
      },
      product_and_services_menu: 'Products and Services',
      products_menu: 'Product List',
      services_menu: 'Services List',
      service: {
        show: 'View Services',
        create: 'Add New Service',
        update: 'Edit Service',
        delete: 'Delete Service',
        restore: 'Restore Service',
        forceDelete: 'Permanently Delete Service'
      },
      categories_menu: 'Product Categories',
      attributes_menu: 'Attributes',
      attribute: {
        show: 'View Attributes',
        create: 'Add Attribute',
        update: 'Edit Attributes',
        updatePriorities: 'Edit Attribute Priorities',
        delete: 'Delete Attribute'
      },
      attribute_values_menu: 'Attribute Values',
      attribute_value: {
        show: 'View Attribute Values',
        create: 'Add Attribute Value',
        update: 'Edit Attribute Value',
        delete: 'Delete Attribute Value'
      },
      warehousing_menu: 'Inventory',
      storeroom_menu: 'Storeroom',
      storeroom: {
        show: 'View Storeroom',
        create: 'Add Storeroom',
        update: 'Fully Edit Storeroom',
        delete: 'Temporarily Delete Storeroom',
        forceDelete: 'Permanently Delete Storeroom',
        restore: 'Restore Storeroom',
        turnover: 'View Storeroom Inventory Turnover',
        inventory: 'View Storeroom Quantity Review',
        inventoryValuation: 'View Storeroom Value Review'
      },
      storeroom_receipts_menu: 'Storeroom Receipts',
      storeroom_receipt: {
        show: 'View Storeroom Receipt',
        create: 'Add Storeroom Receipt',
        update: 'Fully Edit Storeroom Receipt',
        refresh_status: 'Change Storeroom Receipt Status',
        accept: 'Approve Storeroom Receipt',
        partial_accept: 'Partial Approval of Storeroom Receipt',
        delete: 'Temporarily Delete Storeroom Receipt'
      },
      storeroom_deficits_menu: 'Storeroom Deficits and Surpluses',
      storeroom_deficit: {
        show: 'View Storeroom Deficits and Surpluses',
        create: 'Add Storeroom Deficit and Surplus',
        update: 'Edit Storeroom Deficits and Surpluses',
        fullUpdate: 'Fully Edit Storeroom Deficits and Surpluses',
        delete: 'Temporarily Delete Storeroom Deficits and Surpluses'
      },
      storeroom_conversions_menu: 'Inventory Conversions',
      storeroom_conversion: {
        show: 'View Inventory Conversions',
        create: 'Add Inventory Conversion',
        update: 'Edit Inventory Conversion',
        fullUpdate: 'Fully Edit Inventory Conversion',
        delete: 'Temporarily Delete Inventory Conversion'
      },
      treasury_menu: 'Treasury',
      bank_menu: 'Banks',
      bank: {
        show: 'View Banks',
        show_transactions: 'View Bank Transactions',
        create: 'Add Bank',
        update: 'Edit Bank',
        delete: 'Delete Bank',
        restore: 'Restore Bank',
        forceDelete: 'Permanently Delete Bank'
      },
      payment_gateway_menu: 'Payment Gateways',
      payment_gateway: {
        show: 'View Payment Gateways',
        show_transactions: 'View Payment Gateway Transactions',
        create: 'Add Payment Gateway',
        update: 'Edit Payment Gateway',
        delete: 'Delete Payment Gateway',
        restore: 'Restore Payment Gateway',
        forceDelete: 'Permanently Delete Payment Gateway'
      },
      cash_menu: 'Cash Registers',
      cash: {
        show: 'View Cash Registers',
        show_transactions: 'View Cash Transactions',
        create: 'Add Cash Register',
        update: 'Edit Cash Register',
        delete: 'Delete Cash Register',
        restore: 'Restore Cash Register',
        forceDelete: 'Permanently Delete Cash Register'
      },
      payment_menu: 'Payment',
      payment: {
        show: 'View Payment',
        create: 'Add Payment',
        delete: 'Delete Payment',
        restore: 'Restore Payment',
        forceDelete: 'Permanently Delete Payment',
        dynamicDate: 'Register Payment for the Past'
      },
      receive_menu: 'Receive',
      receive: {
        show: 'View Receive',
        create: 'Add Receive',
        return: 'Return Receive',
        delete: 'Delete Receive',
        restore: 'Restore Receive',
        forceDelete: 'Permanently Delete Receive',
        dynamicDate: 'Register Receive for the Past'
      },
      cost_menu: 'Cost',
      cost: {
        show: 'View Cost',
        create: 'Add Cost',
        delete: 'Delete Cost',
        restore: 'Restore Cost',
        forceDelete: 'Permanently Delete Cost',
        dynamicDate: 'Register Cost for the Past'
      },
      internal_fund_menu: 'Internal Fund Transfer',
      internal_fund: {
        show: 'View Internal Fund Transfer',
        create: 'Add Internal Fund Transfer',
        delete: 'Delete Internal Fund Transfer',
        restore: 'Restore Internal Fund Transfer',
        forceDelete: 'Permanently Delete Internal Fund Transfer',
        dynamicDate: 'Register Internal Fund Transfer for the Past'
      },
      accountancy_menu: 'Accountancy',
      opening: {
        access: 'Full Access to Start of Period'
      },
      document: {
        access: 'Full Access to Documents'
      },
      accounts_tree: 'Accounts Tree',
      account: {
        access: 'Full Access to Accounts Tree',
        force_update: 'Mandatory Edit of Accounts Tree'
      },
      tax_menu: 'Tax',
      tax: {
        show: 'View Tax',
        create: 'Add Tax',
        delete: 'Delete Tax',
        restore: 'Restore Tax',
        forceDelete: 'Permanently Delete Tax',
        dynamicDate: 'Register Tax for the Past'
      },
      sales_menu: 'Sales',
      sale_invoices_menu: 'Sales Invoices',
      sale_invoice: {
        show: 'View Sales Invoices',
        create: 'Add Sales Invoice',
        update: 'Edit Sales Invoice',
        fullUpdate: 'Fully Edit Sales Invoice',
        complete: 'Complete Sales Invoice',
        refreshStatus: 'Revert Sales Invoice Status',
        delete: 'Temporarily Delete Sales Invoice',
        forceDelete: 'Permanently Delete Sales Invoice',
        restore: 'Restore Sales Invoice'
      },
      return_sale_invoices_menu: 'Sales Return Invoices',
      return_sale_invoice: {
        show: 'View Sales Return Invoices',
        create: 'Add Sales Return Invoice',
        update: 'Edit Sales Return Invoice',
        fullUpdate: 'Fully Edit Sales Return Invoice',
        refreshStatus: 'Revert Sales Return Invoice Status',
        delete: 'Temporarily Delete Sales Return Invoice',
        forceDelete: 'Permanently Delete Sales Return Invoice',
        restore: 'Restore Sales Return Invoice'
      },
      suggest_sale_invoice: {
        show: 'View Sales Suggestions'
      },
      purchases_menu: 'Purchases',
      purchase_invoices_menu: 'Purchase Invoices',
      purchase_invoice: {
        show: 'View Purchase Invoices',
        create: 'Add Purchase Invoice',
        update: 'Edit Purchase Invoice',
        fullUpdate: 'Fully Edit Purchase Invoice',
        refreshStatus: 'Revert Purchase Invoice Status',
        delete: 'Temporarily Delete Purchase Invoice',
        forceDelete: 'Permanently Delete Purchase Invoice',
        restore: 'Restore Purchase Invoice'
      },
      purchase_invoice_lines_menu: 'Purchase Invoice Lines',
      purchase_invoice_line: {
        create: 'Add Purchase Invoice Item',
        update: 'Edit Purchase Invoice Item',
        fullUpdate: 'Fully Edit Purchase Invoice Item',
        delete: 'Delete Purchase Invoice Item'
      },
      return_purchase_invoices: 'Purchase Return Invoices',
      return_purchase_invoice: {
        show: 'View Purchase Return Invoices',
        create: 'Add Purchase Return Invoice',
        update: 'Edit Purchase Return Invoice',
        fullUpdate: 'Fully Edit Purchase Return Invoice',
        refreshStatus: 'Revert Purchase Return Invoice Status',
        delete: 'Temporarily Delete Purchase Return Invoice',
        forceDelete: 'Permanently Delete Purchase Return Invoice',
        restore: 'Restore Purchase Return Invoice'
      },
      suggest_purchase_invoice: {
        show: 'View Purchase Suggestions'
      },
      connector_menu: 'Connector',
      shops_menu: 'Shops',
      shop: {
        show: 'View Shops',
        create: 'Add New Shop',
        update: 'Edit Shop',
        update_setting: 'Edit Shop Configuration',
        update_storeroom: 'Edit Shop Storerooms',
        delete: 'Temporarily Delete Shop',
        restore: 'Restore Shop',
        forceDelete: 'Permanently Delete Shop'
      },
      woo_controllers_menu: 'Controllers',
      woo_controller_attribute: {
        access: 'Full Access to Attribute Controller'
      },
      woo_controller_product: {
        access: 'Full Access to Product Controller'
      },
      woo_controller_product_price: {
        access: 'Full Access to Product Price Controller'
      },
      woo_controller_product_inventory: {
        access: 'Full Access to Product Inventory Controller'
      },
      woo_controller_user: {
        access: 'Full Access to Customer Controller'
      },
      woo_controller_invoice: {
        access: 'Full Access to Order Controller'
      },
      woo_controller_payment_gateways: {
        access: 'Full Access to Payment Gateway Controller'
      },
      organizational_ticket_menu: 'Organizational Tickets',
      organizational_ticket: {
        show: 'View Organizational Tickets',
        create: 'Create Organizational Ticket',
        delete: 'Delete Organizational Ticket'
      },
      financial_year_menu: 'Financial Years',
      financial_year: {
        show: 'View Financial Year',
        create: 'Create Financial Year',
        switch: 'Change Financial Year'
      },
      setting_menu: 'Settings',
      setting: {
        show: 'View Settings',
        update: 'Edit Settings',
        reset_application: 'Reset Application'
      },
      reports: 'Reports',
      report_tops: {
        show: 'View Top Reports'
      },
      report_chart: {
        show: 'View Charts'
      },
      gross_profit_report: {
        show: 'View Gross Profit Report'
      },
      attributes_profit_report: {
        show: 'View Attribute Gross Profit Report'
      },
      activity_logs: {
        show: 'View Logs'
      },
      log: {
        show: 'Full Access to Logs'
      },
      backup_menu: 'Backup',
      backup: {
        show: 'View Recent Backup Files',
        create: 'Create Backup File',
        restore: 'Restore Backup File'
      },
      is_addons: 'Add-ons',
      addons: {
        woo_controller: 'Controller',
        warehousing: 'Warehousing',
        max_debt: 'Credit Limit',
        points: 'Points'
      }
    },

    actions: {
      insert: 'Add',
      save: 'Register'
    }
  },

  insert: {
    title: 'Add a new user group',

    labels: {
      name: 'User Group Title',
      allowedActiveSession: 'Active sessions allowed',
      access: 'access',
      insert: 'Add',
      inMenu: 'Menu',

      accessList: {
        manager: 'General Manager Access',

        users: {
          totalAccess: 'Full access of persons',
          show: 'View People',
          insert: 'Add person',
          update: 'full edit',
          delete: 'Temporarily delete person',
          setRole: 'Assign a role to a person'
        },

        roles: 'Full access to roles',
        treasury: {
          title: 'Full access to the Treasury',

          bank: 'full access to banks',
          cash: 'Full access to funds'
        },

        reports: {
          title: 'Full access to reports',
          logs: 'access logs'
        },

        delete: {
          title: 'Permanent removal',

          user: 'People',
          banks: 'Banks',
          cash: 'Cashiers'
        }
      }
    }
  },

  edit: {
    title: 'Edit User Group'
  },

  insertUserToAccessGroup: {

    notifications: {
      success: 'access group successfully set to user',
      error: 'set access group to user failed',
      noUserSelected: 'no user selected'
    }
  }
}
